import { BaseService } from '@Services/index'

export class ErrorService extends BaseService {
	
	public error(error: any): Promise<any> {
		return super.sendError(error)
	}
}